export default "__VITE_ASSET__07b5b15d__"